import React, { useState } from "react";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const navigationLinks = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "Coding", href: "/coding" },
    { name: "Photography", href: "/photography" },
    { name: "Coffee", href: "/coffee" },
    { name: "Books", href: "/books" },
  ];

  const moreLinks = [
    { name: "Travel", href: "/travel" },
    { name: "Leadership", href: "/leadership" },
    { name: "Basketball", href: "/basketball" },
    { name: "Sustainability", href: "/sustainability" },
    { name: "Venture Capital", href: "/ventureCapital" },
    
  ];

  return (
    <header
      className="fixed w-full top-0 z-50 border-b border-border"
      style={{
        backgroundColor: 'rgba(10, 10, 10, 0.88)',
        WebkitBackdropFilter: 'blur(12px)',
        backdropFilter: 'blur(12px)',
        WebkitTransform: 'translateZ(0)',
        transform: 'translateZ(0)',
      }}
    >
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="/" className="text-foreground font-semibold text-lg tracking-tight">
            Erick Chandra
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navigationLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-sm text-muted hover:text-foreground transition-colors duration-200"
              >
                {link.name}
              </a>
            ))}
            
            {/* More dropdown */}
            <div className="relative group">
              <button className="text-sm text-muted hover:text-foreground transition-colors duration-200 flex items-center gap-1">
                More
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              <div className="absolute right-0 top-full pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-card border border-border rounded-lg py-2 min-w-[160px] shadow-xl">
                  {moreLinks.map((link) => (
                    <a
                      key={link.name}
                      href={link.href}
                      className="block px-4 py-2 text-sm text-muted hover:text-foreground hover:bg-card-hover transition-colors duration-200"
                    >
                      {link.name}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-foreground p-2"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <nav className="md:hidden py-4 border-t border-border">
            <div className="flex flex-col gap-1">
              {[...navigationLinks, ...moreLinks].map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="px-2 py-3 text-muted hover:text-foreground transition-colors duration-200"
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </a>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
